import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { storage } from "@/modules/storage";
import {
  getAdonisTopRecommendationsId,
  getPlatform,
  getUser,
  getUserPreferences,
  postIncentivesRecordReferralSignupCompleted,
} from "api/methods";
import { PersonalisationWelcomeScreen } from "modules/personalisation/components/PersonalisationWelcomeScreen";

export const PersonalisationWelcomeContainer_PATH = "/personalise/welcome" as const;

export const PersonalisationWelcomeContainer = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { data: user } = useQuery({ ...getUser.keyed() });

  const { data: platform } = useQuery({ ...getPlatform.keyed() });

  const handleGetStarted = () => {
    // Check if user completed onboarding as part of gift card claim flow
    const isGiftCardClaim = storage.getItem("isGiftCardClaim") === "true";

    if (isGiftCardClaim) {
      // Clean up gift card claim flags
      storage.removeItem("isGiftCardClaim");
      storage.removeItem("giftCardRecipientPhone");
      storage.removeItem("giftCardRecipientPlatformUserId");
      storage.removeItem("giftCardImageUrl");
      storage.removeItem("giftCardAmount");
    }

    storage.removeItem("referralCode");
    storage.removeItem("referralSenderName");

    // Invalidate caches so the home and shop pages show fresh
    // personalised recommendations.
    queryClient.invalidateQueries({ queryKey: getUserPreferences.key() });
    queryClient.invalidateQueries({
      queryKey: getAdonisTopRecommendationsId.key({}),
    });

    navigate("/home?fromPersonalisation=true");
  };

  const { mutate: recordReferralSignupCompleted } = useMutation({
    mutationFn: (statelessCode: string) =>
      postIncentivesRecordReferralSignupCompleted({
        statelessCode: statelessCode,
        personId: user?.id as string,
        platformId: user?.platform?.id as string,
        platformLocationId: user?.platformLocation?.id as string,
      }),
    onSuccess: () => {
      console.log("Referral signup completed");
    },
  });

  useEffect(() => {
    const statelessCode = storage.getItem("statelessReferralCode");

    if (statelessCode && user?.id && platform?.id && user?.platformLocation?.id) {
      recordReferralSignupCompleted(statelessCode);
    }
  }, [user, platform, recordReferralSignupCompleted]);

  return (
    <PersonalisationWelcomeScreen
      platformName={platform?.name || ""}
      platformLogoUrl={platform?.logoImageUrl || ""}
      userFirstName={user?.firstName || ""}
      onGetStarted={handleGetStarted}
    />
  );
};
